export interface UseWebSocketParams<T = any> {
  url: string;
  headers: any;

  /** Obs.: Função memorizada */
  onMessage: (data: MessageEvent<T>) => void;
  isConnect?: boolean;
  maxReconnectAttempts?: number;
  reconnectInterval?: number;
}

export interface UseWebSocketProps<T = any> {
  sendJsonMessage: (data: T) => void;

  /**
   * Obs.: Estado do WebSocket
   * •	-1 = UNINSTANTIATED
   * •	0 = CONNECTING
   * •	1 = OPEN
   * •	2 = CLOSING
   * •	3 = CLOSED
   */
  readyState: -1 | 0 | 1 | 2 | 3;
  sendMessage: (data: any) => void;
  reconnect: () => void;
}

export enum ReadyState {
  UNINSTANTIATED = -1,
  CONNECTING = 0,
  OPEN = 1,
  CLOSING = 2,
  CLOSED = 3,
}
